import React from 'react'

const ArrowIcon = props => (
<svg className="icon" width="9px" height="9px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
    
    <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-966.000000, -435.000000)" fill="#325DFA" fillRule="nonzero" id="Group-23" stroke="#325DFA" strokeWidth="0.2">
            <g transform="translate(511.000000, 328.000000)">
                <path d="M457.588257,107.12032 C457.74333,106.959893 457.987466,106.959893 458.14254,107.12032 C458.292374,107.275326 458.292374,107.533309 458.14254,107.687954 L455.332008,110.595502 L464.606379,110.595502 C464.822574,110.595502 465,110.773271 465,110.996929 C465,111.220586 464.822574,111.404137 464.606379,111.404137 L455.332008,111.404137 L458.14254,114.306264 C458.292374,114.466691 458.292374,114.725035 458.14254,114.87968 C457.987466,115.040107 457.74333,115.040107 457.588257,114.87968 L454.112376,111.283817 C453.962541,111.128811 453.962541,110.870828 454.112376,110.716183 L457.588257,107.12032 Z" id="Path-Copy" transform="translate(459.500000, 111.000000) scale(-1, 1) rotate(-135.000000) translate(-459.500000, -111.000000) "></path>
            </g>
        </g>
    </g>
</svg>
)

export default ArrowIcon;